var map = {
	"./dragons-mirror.png": 602,
	"./dragons-mirror.webp": 3707,
	"./olympic-lucks.png": 1099,
	"./olympic-lucks.webp": 1762,
	"./sirens-riches.png": 501,
	"./sirens-riches.webp": 6978,
	"./sunlight-princess.png": 9694,
	"./sunlight-princess.webp": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8362;